<template>
  <page-template >
    <template slot="page-content">
      <div class="generic--template waste-page--template page-template bg-beige pb5">
        <div class="relative z-content">
          <div class="relative container-fluid mw9 center">
            <div class="row relative center mb0 mt4-ns">
              <div class="w-100 col-sm-6">
                <bg-vimeo-video v-if="page.has_bg_video" :vimeoVideoId="page.background_video_vimeo_id"></bg-vimeo-video>
                <img v-else-if="page.hero_image" class="img-responsive" :src="page.hero_image" >
                <img v-else class="img-responsive" v-lazy="'/uploads/9084_Aug10_Gorlin.jpg'" >
              </div> 
              <div class="relative col-xs-12 col-sm-5 col-md-offset-1 ph0">
                <h1 class="db dn-ns f-page-title ttu tl center lh-heading pr0-ns is-blenny is-navy mw7-ns">{{ page.seo_title }}</h1>        
                <div class="dn db-ns abs-vert-center ml0 ml4-m"><h1 class="mw7-ns tl center lh-heading f-page-title ttu is-blenny is-navy">{{ page.seo_title }}</h1></div>
              </div>
            </div>
          </div>
          <section class="relative">
            <div class="relative container-fluid mw9 center">
              <div class="row center">
                <div class="col-xs-12 col-sm-6 mt0 mt5-ns">
                  <div class="row" v-if="page.intro_text">
                    <div class="col-xs-12 col-sm-12 pb4">
                      <h3 class="f2 mb3 is-tablet-bold is-navy lh-title">{{page.headline_text}}</h3>
                      <div class="f22px is-tablet-regular link-bold lh-copy cms-content" v-html="marked(page.intro_text)"></div>
                    </div>
                  </div>
                </div>
                <div class="dn dn-m db-l col-sm-3 col-sm-offset-1">
                  <div class="dn db-ns icon-image relative nt5 center">
                    <img class="db relative center w-100 mw20rem z-0" :src="page.secondary_image" />
                    <!-- <img class="absolute right-0 mw4 mt4" :src="page.page_icon_image" /> -->
                  </div>
                </div>
              </div>
              <div class="row center">
                <div class="col-xs-12 col-sm-12">
                  <h2 class="f1 mw7 ttu is-blenny is-navy">{{ page.clean_vibes_headline }}</h2>
                </div>
              </div>                
            </div>
          </section>
        </div>

        <div class="relative z-content">
          <div class="relative container-fluid mw8 center">

            <div class="row relative center mb4 mt4-ns is-black">
              <!-- <h2 class="f1 is-lorano-bold ttu mt5"> {{ page.waste_content.title }}</h2> -->
              <div class="col-xs-12 col-sm-6 mt5">
                <h2 v-if="page.waste_content.sub_header_text" class="f2 is-tablet-bold is-navy mb4">{{ page.waste_content.sub_header_text }}</h2>
                <div class="row mb4" v-for="(item, index) in page.waste_content.list">
                  <div class="col-xs-3 col-sm-3">
                    <simple-svg class="db relative w3 waste-navy-svg" :filepath="item.image"></simple-svg>
                    <!--<img class="db relative center " v-lazy="item.image" :alt="item.title" />-->
                  </div>
                  <div class="col-xs-9 col-sm-9">
                    <h3 class="is-tablet-cond-bold f25px mb2 is-navy">{{ item.title }}</h3>
                    <p class="is-tablet-wide-bold f35px mb2 is-navy">{{ item.tons }}</p>
                    <p class="is-tablet-bold f15px is-red">{{ item.pounds }}</p>
                  </div>
                </div>
                <div class="db relative">
                  <div class="" v-for="(item, index) in page.waste_content.totals_list">
                    <h3 class="is-tablet-bold f25px mb2 is-navy">{{ item.text }}<span class="dib f4 is-tablet-bold is-red">{{ item.pounds }}</span></h3>
                  </div>
                </div>

              </div>
              <div class="col-xs-12 col-sm-6 mt2 mt5-ns">
                <!--<img class="db relative center img-responsive" v-lazy="page.waste_content.pie_chart_image" alt="2018 Waste Diversion Graphic" />-->
                <h3 class="is-tablet-bold f20px mb2 is-navy">{{ page.recycling_breakdown.title }} 1</h3>
                <div class="db relative mv4" v-for="(item, index) in page.recycling_breakdown.list">
                  <h4 class="is-tablet-regular f4 mb3 is-navy">{{ item.title }}</h4>
                  <img class="dib relative" v-lazy="item.image" :alt="'2019 Waste Diversion Graphic' + index" :class="{'w86px': index == 2, 'w52px': index == 3, 'w51px': index == 4, 'w29px': index == 5  }" />
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="relative bg-light-blue z-content mb5" v-if="isWindowWidthMobile == true && page.featured_content_section.is_published">
          <section class="relative center pv4 is-black">
            <swiper :options="swiperOptions" ref="mySwiper">
              <swiper-slide>
                <div class="relative container-fluid">
                  <div class="db w-100">
                    <img class="db relative center img-responsive w-100" :src="page.featured_content_section.content['0'].image" :alt="page.featured_content_section.content['0'].image.alt"/>
                    <h3 class="f20px is-tablet-cond-bold mt4 mb3">{{ page.featured_content_section.content['0'].title }}</h3>
                    <p class="f15px is-tablet-regular mb3 lh-copy">{{ page.featured_content_section.content['0'].text }}</p>
                    <a class="f15px is-tablet-bold" :title="page.featured_content_section.content['0'].link_title" :href="page.featured_content_section.content['0'].link">{{  page.featured_content_section.content['0'].button_text }}<simple-svg class="checkout" :filepath="'/uploads/checkout-arrow.svg'"></simple-svg></a>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="relative container-fluid">
                  <div class="db w-100">
                    <img class="db relative center img-responsive w-100" :src="page.featured_content_section.content['1'].image" :alt="page.featured_content_section.content['1'].image.alt"/>
                    <h3 class="f20px is-tablet-cond-bold mt4 mb3">{{ page.featured_content_section.content['1'].title }}</h3>
                    <p class="f15px is-tablet-regular mb3 lh-copy">{{ page.featured_content_section.content['1'].text }}</p>
                    <a class="f15px is-tablet-bold" :title="page.featured_content_section.content['1'].link_title" :href="page.featured_content_section.content['1'].link">{{  page.featured_content_section.content['1'].button_text }}<simple-svg class="checkout" :filepath="'/uploads/checkout-arrow.svg'"></simple-svg></a>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </section>
        </div>

        <div class="relative bg-pink z-content mb5 mt4" v-if="isWindowWidthMobile == false && page.featured_content_section.is_published">
          <div class="relative container-fluid">
            <section class="relative center mw8 pt5 pb5 is-black">
              <div class="row">
                <div class="col-xs-12 col-sm-6 pr5-ns br-ns b--is-cream">
                  <img class="db relative center img-responsive w-100" :src="page.featured_content_section.content['0'].image" :alt="page.featured_content_section.content['0'].image.alt"/>
                  <h3 class="f20px is-tablet-cond-bold mt4 mb3">{{ page.featured_content_section.content['0'].title }}</h3>
                  <p class="f15px is-tablet-regular mb3 lh-copy">{{ page.featured_content_section.content['0'].text }}</p>
                  <a class="f15px is-tablet-bold" :title="page.featured_content_section.content['0'].link_title" :href="page.featured_content_section.content['0'].link">{{  page.featured_content_section.content['0'].button_text }}<simple-svg class="checkout" :filepath="'/uploads/checkout-arrow.svg'"></simple-svg></a>
                </div>
                <div class="col-xs-12 col-sm-6 pl5-ns pt5 pt0-m pt0-l ">
                  <img class="db relative center img-responsive w-100 pt4 pt0-m pt0-l" :src="page.featured_content_section.content['1'].image" :alt="page.featured_content_section.content['1'].image.alt"/>
                  <h3 class="f20px is-tablet-cond-bold mt4 mb3">{{ page.featured_content_section.content['1'].title }}</h3>
                  <p class="f15px is-tablet-regular mb3 lh-copy">{{ page.featured_content_section.content['1'].text }}</p>
                  <a class="f15px is-tablet-bold" :title="page.featured_content_section.content['1'].link_title" :href="page.featured_content_section.content['1'].link">{{  page.featured_content_section.content['1'].button_text }}<simple-svg class="checkout" :filepath="'/uploads/checkout-arrow.svg'"></simple-svg></a>
                </div>
              </div>
            </section>
          </div>
        </div>

      </div>
    </template>
  </page-template>
</template>

<script>
import PageTemplate from './page-template.vue';
import BgVimeoVideo from './bg-vimeo-video.vue';
export default {
  components: {
    PageTemplate,
    BgVimeoVideo
  },
  props: ['id','pageMarkdownFileName'],
  metaInfo () {
    return {
      title: this.page.seo_title,
      titleTemplate: (titleChunk) => {
        return titleChunk ? `${titleChunk} | ` + this.$site_seo_title_suffix : this.$site_seo_title_suffix;
      },
      meta: [
        { vmid: 'description', name: 'description', content: this.page.seo_description }
      ]
    }
  },
  data () {
    return {
      bgOpaciy: 0,
      bgScrollStart: this.$bgScrollStart,
      scrollPos: 0,
      parallax:null,
      parallax2:true,
      window: {
        width: 0,
        height: 0
      },
      isWindowWidthMobile: null,
      swiperOptions: {
          autoplay: {
            delay: 7000,
          },
          speed: 800,
          autoplayDisableOnInteraction: false,
          // loop: true,
          initialSlide: 0,
          //pagination: '.swiper-pagination',
          paginationClickable: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: false,
          },
          keyboardControl: true,
          // navigation: {
          //   nextEl: '.swiper-button-next',
          //   prevEl: '.swiper-button-prev'
          // },
          initialSlide: 0,
          spaceBetween: 15,
          freeMode: false,
          slidesPerView: 1.3,
        }
    }
  },
  computed: {
    page: function () {
      var pageData = this.$store.getters.filterPagesByName(this.pageMarkdownFileName);
      return pageData[0];
    },
    swiper() {
      if(this.$refs.mySwiper)
        return this.$refs.mySwiper.swiper
    },
  },
  methods : {
    scrollBg: function() {
      if (window.scrollY > this.bgScrollStart) {
        // console.log('scrollBg', window.scrollY, this.bgOpaciy);
          if ((document.body.getBoundingClientRect()).top > this.scrollPos) {
            if (window.scrollY > this.bgScrollStart) {
              this.bgOpaciy = (window.scrollY * 0.001);
              //console.log('SCROLL UP: ', window.scrollY, this.bgOpaciy);
            }
            else {
              this.bgOpacity = 0;
            }
          }
          else {
            this.bgOpaciy = (window.scrollY * 0.001);
            //console.log('SCROLL DOWN: ', window.scrollY, this.bgOpaciy);
          }
          // saves the new position for iteration.
          this.scrollPos = (document.body.getBoundingClientRect()).top;
      }
      else {
        this.bgOpaciy = 0;
      }
    },
    sizing: function(){
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.window.width < 768)
        this.isWindowWidthMobile = true; 
      else{
        this.isWindowWidthMobile = false; 
        this.mobileActive = -1;
      }
      this.scrollBg();
      if(this.swiper)
        this.swiper.update();
    },
    /*calcParallax: function(myTarget, offset, movement, positioning){
      if(this.$refs[myTarget]){
        this.parallax2 = false;
        if((this.$refs[myTarget].parentElement.getBoundingClientRect().y + offset + this.$refs[myTarget].getBoundingClientRect().height) + movement > 0 && (this.$refs[myTarget].parentElement.getBoundingClientRect().y + offset) - movement  < window.innerHeight){
          var newMovement = offset + (((this.$refs[myTarget].parentElement.getBoundingClientRect().y + offset + (this.$refs[myTarget].getBoundingClientRect().height / 2) - (window.innerHeight / 2) - 27) / window.innerHeight) * movement);
          return 'top:'+newMovement+'px;'+positioning;
        } else {
          return 'display:none;';
        }
      }
    },*/
  },
  created() {
    var w = window.innerWidth;
    if (w < 768) {
      this.isWindowWidthMobile = true; 
    }
    else {
      this.isWindowWidthMobile = false; 
    }
    window.addEventListener('resize', this.sizing);
    window.addEventListener('scroll', this.scrollBg);
    window.addEventListener('load', this.sizing);
  },
  beforeMount() {
    //
  },
  mounted() {
    setInterval(() => {
      if(this.parallax2 !== false)
        this.parallax = this.parallax + 0.02;
    }), 10;
    this.$nextTick(() => {
      //
    })

  },
  beforeDestroy() {
    //
  },
  destroyed() {
    window.removeEventListener('resize', this.sizing);
    window.removeEventListener('scroll', this.scrollBg);
    window.removeEventListener('load', this.sizing);
  }
}
</script>
